import React from "react"
import { Input } from "reactstrap"
import { t } from "@lingui/macro"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import styles from "./SearchBar.module.css"

const SearchBar = ({ setter, data }) => {
  const onChange = ({ target }) => {
    const name = target.value
    if (name !== "") {
      const results = data.filter((member) => {
        return member.full_name
          .toLocaleLowerCase()
          .startsWith(name.toLocaleLowerCase())
      })
      setter(results)
    } else {
      setter(data)
    }
  }
  return (
    <div className={styles.searchContainer}>
      <FontAwesomeIcon icon={faSearch} color="#757575" />
      <Input
        onChange={onChange}
        name="member-search-bar"
        type="search"
        placeholder={t({ id: "Search" })}
        className={styles.searchInput}
      />
    </div>
  )
}

SearchBar.propTypes = {
  setter: PropTypes.func,
  data: PropTypes.array,
}

export default SearchBar
